














































import {Component, Vue} from "vue-property-decorator";
import {deepCopy} from "@/auxillary"
import {MdbsIdProvider} from "@/api/tsclient";
import ConfirmDialog from "../ConfirmDialog.vue";
import {currentUserModule, instituteWithStudySystemModule} from "@/store";
import InstituteEditDialog from "@/components/institute/InstituteEditDialog.vue";
import InstituteDto = MdbsIdProvider.InstituteDto;

@Component({
  components: {
    InstituteEditDialog,
    ConfirmDialog
  },
})
export default class InstituteTable extends Vue {

  headers: Array<any> = [{
    text: "Kennung",
    value: "identifier"
  },
    {
      text: "Anzeigename",
      value: "displayName"
    },
    {
      text: 'Aktionen',
      sortable: false,
      width: '60px',
      value: 'actions'
    }
  ]
  options: any = {
    sortBy: ['displayName'],
    sortDesc: [false]
  };
  search: string = "";

  itemToDelete: MdbsIdProvider.InstituteDto | null = null;
  itemToEdit: MdbsIdProvider.InstituteDto | null = null;

  get showEditDialog() {
    return this.itemToEdit != null;
  }

  set showEditDialog(value: boolean) {
    if (!value) {
      this.itemToEdit = null;
    }
  }

  get canEdit() {
    return currentUserModule.hasRight("InstituteUpdateCmd");
  }

  get canCreate() {
    return currentUserModule.hasRight("InstituteCreateCmd");
  }

  get institutes() {
    return instituteWithStudySystemModule.institutesWithStudySystem;
  }

  get loading() {
    return instituteWithStudySystemModule.loading;
  }

  async mounted() {
    await instituteWithStudySystemModule.loadAll()
  }

  newInstitute() {
    this.itemToEdit = new InstituteDto({
      id: "",
      identifier: "",
      displayName: ""
    })
  }

  editInstitute(institute: InstituteDto) {
    this.itemToEdit = deepCopy(institute)
  }


  async saveInstitute(institute: InstituteDto) {
    if (this.itemToEdit == null)
      return;
    let instituteToSave = institute;
    this.itemToEdit = null;
    console.log(instituteToSave)
    //TODO: Fix me
    /*if (instituteToSave.id == null || instituteToSave.id == "") {
      await instituteWithStudySystemModule.createInstituteWithStudySystem({
        identifier: instituteToSave.identifier ?? "",
        displayName: instituteToSave.displayName ?? ""
      })
    } else {
      await instituteWithStudySystemModule.updateInstitute({
        id: instituteToSave.id,
        identifier: instituteToSave.identifier ?? "",
        displayName: instituteToSave.displayName ?? ""
      })
    }*/
  }

}

